import { lazy } from 'react';
import { authRoles } from 'app/auth';

const QuestionnaireList = lazy(() =>
  import('./use-cases/questionnaire-list/QuestionnaireDashboard')
);
const QuestionnaireBuilder = lazy(() =>
  import('./use-cases/questionnaire-builder/QuestionnaireBuilder')
);
const OrganisationQuestionnaireDashboard = lazy(() =>
  import('./use-cases/organisation-questionnaire-list')
);
const OrganisationQuestionnaireBuilder = lazy(() =>
  import('./use-cases/organisation-questionnaire-builder')
);

const QuestionnaireConfig = {
  settings: {
    layout: {
      config: {
        healtheraHeader: {
          display: true,
        },
        footer: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'questionnaires/:questionnaireId/builder',
      element: <QuestionnaireBuilder />,
    },
    {
      path: 'questionnaires',
      element: <QuestionnaireList />,
    },
    {
      path: 'organisation-questionnaires',
      element: <OrganisationQuestionnaireDashboard />,
      auth: authRoles.pharmacist,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: true,
              },
            },
          },
        },
      },
    },
    {
      path: 'organisation-questionnaires/:questionnaireId/builder',
      element: <OrganisationQuestionnaireBuilder />,
      auth: authRoles.pharmacist,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                organisationSelector: true,
              },
            },
          },
        },
      },
    },
  ],
};

export default QuestionnaireConfig;
